module.exports = __webpack_public_path__ + "img/nz.e7d2be7e.svg";